import type { TDocumentDefinitions } from 'pdfmake/interfaces'
import { getFirma } from '@/modules/Core/usings/impresion'
import type { IConfPersonasEmpleado } from '@/modules/Administracion/interfaces'

import type { IConfDocjsonparametros } from '@/modules/Configuracion/interfaces'
import { useDocumentosPdf } from '@/modules/Configuracion/composables/useDocumentosPdf'
import { docJsonService } from '@/services'

import type { ICitaTechnologiasSalud } from '../interfaces'
import { tipoImpresionAsistencialDefault } from '@/modules/Core/usings/constantes'

export function useDocumentoAtencionPdf() {
        const { openAndGeneratecreatePdf } = useDocumentosPdf()
        const handleGenerarPdf = async (item: ICitaTechnologiasSalud) => {
            const parametros = [
                {
                cdjpNombre: 'P_CITT_ID',
                valor: item.cittId?.toString()
                }
            ] as IConfDocjsonparametros[]
            const { data: dataDoc } = await docJsonService.list({
                cofoTipoDocumento: 'IMPRESION_ATENCION',
                coseId: item.contratoxservicio?.coseId,
                cocuId: item.contratoxservicio?.cocuId,
                cofoEstado: 1
            })
            if (dataDoc.error || !dataDoc.body || dataDoc.body.length === 0) return false
            const docSeleccionado = dataDoc.body[0]
            for await (const reporte of docSeleccionado.reportes) {
                    if(reporte.reporte && reporte.reporte.parametros) {
                        for await (const parametro of reporte.reporte.parametros) {
                            const parametroExtraido = parametros.find(p => p.cdjpNombre === parametro.corpNombre)
                            if (parametroExtraido) {
                                parametro.valor = parametroExtraido.valor
                            }
                        }
                    }
                }
                const firmasDocDefinition = [
                {
                    columns: [],
                    columnGap: 5,
                    margin: [
                        0,
                        0,
                        0,
                        12
                    ]
                }
            ] as TDocumentDefinitions['content'];
            const images = {}
            if (docSeleccionado.cofoFirma !== 0) {
                const stack = await getFirma(item.empleado as IConfPersonasEmpleado)
                firmasDocDefinition[0].columns = [{ stack }]
            }
            await openAndGeneratecreatePdf({ doc: docSeleccionado,  withParams: true, firmas: { firmas: firmasDocDefinition, images }  })
            return true
        }
        const generarDocumentoAtencion= async (item: ICitaTechnologiasSalud, tipo: tipoImpresionAsistencialDefault) => {
            if (tipo !== tipoImpresionAsistencialDefault.PROCEDIMIENTOS) return false
            return await handleGenerarPdf(item)
        }
        return {
            generarDocumentoAtencion,
            handleGenerarPdf
        }
  }
